import React from "react";
import { useState, useEffect } from 'react';

// tools and component for date picker
import dayjs from 'dayjs';

//selectors for redux :
import { useSelector } from "react-redux";
import { getIdSpot, getLivraison, getRidingPeriod, getPanier } from "../../../../../../store/selectors.js";


//import Fetch API functions
import { getArticles, getOneSpot } from '../../../../../../database/fetchApi.js'

//created components
import RecapStep from '../../../commons/recapstep/RecapStep.jsx'
import HeaderStep from "../../../../../../commons/headerstep/HeaderStep.jsx";
import InfosRecap1 from "../../../../../../steps/step2/components/infosrecap1/InfosRecap1.jsx";
import InfosRecap2 from "../../components/infosrecap2/InfosRecap2.jsx";
import InfosPanierFinal from "../../components/infospanierfinal/InfosPanierFinal.jsx";
import FormulaireInfosClient from "../../components/formulaireinfosclient/FormulaireInfosClient.jsx";

//Utils functions
import { prepareDureeTexte } from '../../../../../../utils/calcul_duree.js'
import calculDuree from '../../../../../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)
import { calcPrix, calcPrixDegressif } from "../../../../../../utils/calcul_prix.js" //parms : tarifs object, duree object


//Translate utils :
import { translator } from "../../../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function StepThree() { // component to manage the first step of shopping : choosing place and time

    const [articles, setArticles] = useState([]);
    const [spotInfos, setSpotInfos] = useState(null); //null is set by default so we can 

    const idSpot = useSelector(getIdSpot); //global state : id of the selected spo
    const infosLivraison = useSelector(getLivraison); //global state : id of the selected spo
    let period = useSelector(getRidingPeriod); //global state : id of the selected spo
    let panier = useSelector(getPanier); //get global state : panier
    const lang = useSelector(getLang) //global state : language
    const dureeObject = calculDuree(period); //get object with quantity for every durations (demis,jour, semaine...)

    React.useEffect(() => { //change opening hours when spot change (idspot as dependency)

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initSpot() { //we add this inner function to manage asynchrone
            let infosSpot = await getOneSpot(idSpot);
            setSpotInfos(infosSpot)
        } //end of async function
        initSpot(); //call the inner asnchrone function 

    }, [])




    /*   function prepareInfosPanier() {
          let cumulPanier = { qte: 0, total: 0 }
          let pu = 0;
          if (panier.length > 0) {
              panier.map((item) => {
                  cumulPanier.qte += item.qte;
                  let currentArticle = articles.filter((article) => article.id_article === item.id_article);
                  if (currentArticle.length > 0) { //verify if exist
                      pu = calcPrix(currentArticle[0].Tarif, dureeObject);
                  }
                  cumulPanier.total += (pu * item.qte);
              })
          }
          return cumulPanier
      } */

    function prepareInfos() { // for duration recap

        console.log("period:", period);

        let spot = "";
        let dates = "";
        let duree = "";

        // prepare spot infos
        if (idSpot >= 99) {
            spot = "Livraison : " + infosLivraison.secteur + " , " + infosLivraison.adresse; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
        }
        else { // spot is not livraion
            if (spotInfos) { // if promise not fullfilled yet, we block the process to evoid error
                spot = spotInfos.nom_spot + ", " + spotInfos.adresse_spot + " " + spotInfos.ville_spot;
            }
        }

        //prepare dates infos
        dates += "du " + dayjs(period[0][0]).format("DD/MM/YYYY");
        dates += " à " + period[1][0] + "h00";
        dates += " au " + dayjs(period[0][1]).format("DD/MM/YYYY");
        dates += " à " + period[1][1] + "h00";

        //Prepare duree infos
        duree = prepareDureeTexte(dureeObject);

        return { spot, dates, duree }
    }

    /*    function prepareInfos2() { // for panier recap
           let lignes = [];
           lignes.push("ligne 1");
           lignes.push("ligne 2");
           lignes.push("ligne 3");
           lignes.push("ligne 4");
   
   
           return lignes
       } */

    //let periode = useSelector(getRidingPeriod);

    function findArticle(id) {
        try {
            return articles.find((item) => item.id_article === id);

        }
        catch {
            console.log('error find')
        }
    }

    function getCumul() {
        let total = 0;
        let lignes = [];


        if (panier.length > 0) {
            panier.map((ligne) => {
                let articleCourant = findArticle(ligne.id_article);
                if (typeof articleCourant !== 'undefined') {
                    let pu = ligne.qte * calcPrixDegressif(articleCourant.Tarif, calculDuree(period));
                    let infosArticle = ligne.qte + " x " + articleCourant.type + " : " + pu + ",00€";
                    total += pu;
                    lignes.push(infosArticle);
                }
            });
        }

        return { total, lignes };
    }

    return (
        <div className="step2">

            <div className="step2-top">
                <RecapStep step={1} infos={<InfosRecap1 infos={prepareInfos()} />} /* custom={<InfosRecap1 />} */ />
                <RecapStep step={2} infos={<InfosRecap2 infos={getCumul().lignes} />} custom={<InfosPanierFinal total={getCumul().total} />} />

                <HeaderStep step={3} title={translator("Informations client", lang, "headerStep3")} articles={articles} />
            </div>

            <div className="step3-infos-client">
                <FormulaireInfosClient />
            </div>

        </div>

    )
}




export default StepThree